/**
 * 轮播图
 */

export const SlideshowList = [
    {
        prop: "number",
        label: "优先级",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "url",
        label: "轮播图",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "creatorName",
        label: "创建人",
        width: "150",
        format: "type",
        order: false,
        isShow: true
    },
    {
        prop: "creationTime",
        label: "创建时间",
        width: "150",
        format: "datetime",
        order: false,
        isShow: true
    }
]